import { createContext } from "react";

const VisitasContext = createContext();

export default VisitasContext;
